<template>
  <div id="app">
    <!-- Reference - https://github.com/hasanparasteh/ResponsiveVueNavbar -->
    <div style="margin-bottom: 100px; ">
      <Header
        name=""
        :navLinks="[
          {
            name: 'Home',
            link: '/',
            dropdown: false
          },
          { name: 'Students', link: '/students', dropdown: false },
          { name: 'Calculator', link: '/calculator', dropdown: false },
          { name: 'Bitcoin (Api)', link: '/bitcoin', dropdown: false },
          { name: 'To Do', link: '/todolist', dropdown: false },
          { name: 'To Do (Api)', link: '/todolistapi', dropdown: false },
          { name: 'ECommerce', link: '/ecommerce', dropdown: false },
          { name: 'Currency Convertor', link: '/currency', dropdown: false },
          { name: 'Endgame', link: '/battle', dropdown: false }
        ]"
      />
    </div>

    <router-view />
    <Footer />
  </div>
</template>
<script>
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
export default {
  name: "app",
  components: {
    Header,
    Footer
  }
};
</script>
<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  padding: 0 20px;
}

#nav {
  padding: 10px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  overflow-x: hidden;
}
</style>
